import { BaseModel } from "@/models/base.model"
import type { IFileBucket } from "@/interfaces/api/file-bucket.interface"
import { FileRelation } from "@/models/file/file-relation.model"
import { ModelFactory } from "@/factories/model-factory"

export class FileBucket extends BaseModel implements IFileBucket {
  fileRelations: FileRelation[]

  constructor(fileBucket: IFileBucket, managed = false) {
    super(fileBucket)

    this.fileRelations = ModelFactory.childModels(FileRelation, fileBucket.fileRelations, managed)
  }
}
